import gql from 'graphql-tag';

export const DEAL_SHEET_CONFIGURATION_FRAGMENT = gql`
  fragment DealSheetConfig on DealSheetConfigurationViewModel {
    id
    name
    isGlobal
    description
    charges {
      data {
        name
        type
        amount
        isTaxable
        amountType
        equipmentId
        description
      }
    }

    dealRules {
      location
      customer
      equipment
    }

    createdBy {
      id
      email
      fullName
    }

    updatedDateTime
    createdDateTime
  }
`;
